define(["backbone", "jquery", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  $,
  Properties,
  Messenger,
) {
  "use strict";

  const TopicListingModel = {};

  TopicListingModel.topicListingExport = Backbone.Model.extend({
    defaults: function () {
      return {
        abbreviated: false,
        includeBranchTopics: false,
        localeIds: [],
        showBlankResponses: false,
        touchPointIds: [],
        fileName: "Topic Listing.csv",
        tableHeaders: this._getTopicListingHeaders(),
      };
    },

    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/reports/topicListingDownload`;
    },

    _getTopicListingHeaders: function () {
      const isResponseReview = Messenger.reqres.request("active:kb:model").get("responseReview");
      const headers = [
        { headerName: $.t("reports.topicListing.topicId"), modelAttribute: "topicID" },
        { headerName: $.t("reports.topicListing.topicName"), modelAttribute: "topicName" },
        { headerName: $.t("reports.topicListing.topicNotes"), modelAttribute: "topicNotes" },
        { headerName: $.t("reports.topicListing.topicLabel"), modelAttribute: "topicLabel" },
        {
          headerName: $.t("reports.topicListing.topicLabelTouchpoint"),
          modelAttribute: "topicLabelTouchpoint",
        },
        { headerName: $.t("reports.topicListing.response"), modelAttribute: "response" },
        { headerName: $.t("reports.topicListing.reasonCode"), modelAttribute: "reasonCode" },
        { headerName: $.t("reports.topicListing.touchpoint"), modelAttribute: "touchpoint" },
        { headerName: $.t("reports.topicListing.language"), modelAttribute: "language" },
        { headerName: $.t("reports.topicListing.categories"), modelAttribute: "categories" },
        { headerName: $.t("reports.topicListing.attributes"), modelAttribute: "attributes" },
        { headerName: $.t("reports.topicListing.status"), modelAttribute: "status" },
        { headerName: $.t("reports.topicListing.context"), modelAttribute: "context" },
        {
          headerName: $.t("reports.topicListing.associatedContent"),
          modelAttribute: "associatedContent",
        },
        {
          headerName: $.t("reports.topicListing.lastUpdatedDate"),
          modelAttribute: "lastUpdatedDate",
          dateField: true,
        },
      ];
      if (isResponseReview) {
        headers.push(
          {
            headerName: $.t("reports.topicListing.reviewedOnDate"),
            modelAttribute: "reviewedTimestamp",
            dateField: true,
          },
          {
            headerName: $.t("reports.topicListing.reviewedByUser"),
            modelAttribute: "reviewedUserName",
          },
        );
      }
      return headers;
    },
  });

  return TopicListingModel;
});
